module.exports = __webpack_public_path__ + "static/media/Logo sanggar anak akar.ecf964df.jpg";